import type React from 'react';
import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, PrimaryButton, Row } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

import localeEs from '@/views/AdminDashboard/i18n/localeEs';

interface ErrorCaseProps {
  msg?: string;
  refetch: () => void;
}

const ErrorCase: FC<React.PropsWithChildren<ErrorCaseProps>> = ({
  refetch,
  msg,
}) => {
  const { t } = useTranslation();
  const { isDark } = useUITheme();

  return (
    <div
      className={`${
        isDark ? 'bg-base-lighter-16' : 'bg-white shadow-dropdown'
      } mb-24 mt-32 rounded-5`}
    >
      <Row nowrap className="flex justify-center">
        <Col xs={12} sm={10} lg={8}>
          <div className="flex flex-col items-center text-center py-16 px-16 sm:py-32 sm:px-0">
            <h4 className="font-h4 mb-16 text-center">
              {t('ERROR_CASE_TITLE', {
                defaultValue: localeEs.es.ERROR_CASE_TITLE,
              })}
            </h4>
            {msg ? (
              <p className="font-body3 text-red-main mb-16">{msg}</p>
            ) : (
              <p className="font-body3 mb-16">
                {t('ERROR_CASE_BODY', {
                  defaultValue: localeEs.es.ERROR_CASE_BODY,
                })}
              </p>
            )}
            <PrimaryButton
              label={t('ERROR_CASE_BUTTON', {
                defaultValue: localeEs.es.ERROR_CASE_BUTTON,
              })}
              size="s"
              onClick={refetch}
              darkMode={isDark}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ErrorCase;
